import {
  ANALYTIC_EVENT_ACTIONS,
  ANALYTIC_EVENT_LABELS,
  ANALYTIC_EVENT_TYPES,
  EventCategories,
} from '@lentau/analytics/events/shared';

export const getGBInitEvent = (time: number) => ({
  event: ANALYTIC_EVENT_TYPES.OWOX,
  eventCategory: EventCategories.MONITORING,
  eventAction: ANALYTIC_EVENT_ACTIONS.get_response,
  eventLabel: ANALYTIC_EVENT_LABELS.growthBook,
  eventContext: `${time}`,
});
